<template>
  <div id="app">
    <router-view></router-view>
  </div>
</template>

<script>
import AppHeader from '@/components/header/AppHeader'
export default {
  name: 'app',
  components: {
    'app-header': AppHeader
  }
}
</script>

<style>
@import "./assets/css/reset.css";
@import "./assets/css/whhg.css";

body {
  margin: 0px;
  width: 100%;
}
#headerBlank {
  height: 11vh;
  max-height: 80px;
  min-height: 30px;
}

#app {
  text-align: center;
}

.orangedBackground {
  background-color: #ffd500;
}
.bluedBackground {
  background-color: #0065B3;
}
.subOranged {
  background-color: #E69200;
}
</style>



// WEBPACK FOOTER //
// App.vue?77d678f8